// extracted by mini-css-extract-plugin
module.exports = {"container":"LayerButton_container__JG9Bh","counterBadge":"LayerButton_counterBadge__nVKrQ"};